import React, { useState } from 'react';

import HTMLPreview from './HTMLPreview';
import PDFPreview from './PDFPreview';
import DropDown from '../../containers/Onboarding/CompanyOnboarding/dropdown';
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { hideModal, loadModal } from 'src/redux/modal/action';

const PreviewContainer = ({
  preview,
  previews,
  previewLoaded,
  locales,
  hasPDFAccess,
  hasBothPolicies,
  handlePolicyChange,
  cookieAccessible,
  privacyAccessible,
  policyType,
  policySelected,
  loadModal,
  t,
}) => {
  const [selectedLocale, switchLocale] = useState(locales[0].isoCode);
  const [selectedFormat, toggleFormat] = useState('online');

  const generateLocaleOptions = () => {
    return locales.map(({ isoCode }) => ({ value: isoCode, label: t(`.${isoCode}`) }));
  };

  return (
    <div className='preview_container'>
      {hasBothPolicies && (
        <ul className='preview__policies'>
          <li
            onClick={() => privacyAccessible && handlePolicyChange('privacy')}
            className={`preview__policies--item ${policySelected === 'privacy' &&
              'active'} ${!privacyAccessible && 'disabled'}`}
          >
            {t('.privacy_policy')} ({t(`.${previews['privacy'].status}`)})
          </li>
          <li
            onClick={() => cookieAccessible && handlePolicyChange('cookie')}
            className={`preview__policies--item ${policySelected === 'cookie' &&
              'active'} ${!cookieAccessible && 'disabled'}`}
          >
            {t('.cookie_policy')} ({t(`.${previews['cookie'].status}`)})
          </li>
        </ul>
      )}
      <div className='preview__header'>
        <ul className='preview__types'>
          <li
            className={`preview__link ${selectedFormat === 'online' && 'active'}`}
            onClick={() => {
              toggleFormat('online');
            }}
          >
            {' '}
            {t('.online_preview')}{' '}
          </li>
          {/* {hasPDFAccess && ( */}
          <li
            className={`preview__link ${selectedFormat === 'pdf' && 'active'}`}
            onClick={() => {
              if (hasPDFAccess) {
                toggleFormat('pdf');
              }
              else {
                loadModal({
                  modalType: 'access_limit_user_model',
                  content: {
                  },
                  title: '',
                  t,
                })
              }
            }}
          >
            {' '}
            {t('.pdf_preview')}{' '}
          </li>
          {/* )} */}
        </ul>
        <DropDown
          options={locales ? generateLocaleOptions() : []}
          handleChange={e => switchLocale(e.target.value)}
          size='small'
          className='margin-right-20'
          isPill
          value={selectedLocale}
          name={'language'}
        />
      </div>
      {previewLoaded && (
        <div className='preview'>
          {selectedFormat === 'online' && (
            <HTMLPreview preview={preview.htmlPreview[selectedLocale]} />
          )}
          {selectedFormat === 'pdf' && (
            <PDFPreview preview={preview.pdfLink} selectedLocale={selectedLocale} />
          )}
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  closeExampleModal: hideModal,
  loadModal
}

export default compose(
  connect(null, mapDispatchToProps),
)(PreviewContainer)
